import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
export class BigDeal{
  start?:string;
  end?:string;
  color?:string;
  active?:boolean;
  logo: string;
  from:string;
  to:string;
  dealBanners?:DealBanner[]=[]
}
@Injectable({
  providedIn: 'root'
})
export class FestivalDealService {
  private _bigDeals:Subject<any> = new Subject();
  public readonly bigDeals$=this._bigDeals.asObservable().pipe(tap(x=>console.log(x)))
  constructor(private http:HttpClient) {

  }

  getDeal():Observable<BigDeal[]>{
    return this.http.get<BigDeal[]>(environment.BASE_URL + "/big-deal").pipe(map((x:any[])=>{
      let bigDeals:BigDeal[] =[]
      x.forEach(element => {
        let u = {...element}
        if(element.from != undefined && element.from != null){
          u.start = element.from;
        }
        if(element.to != undefined && element.to != null){
          u.end = element.to;
        }
        if(u.color== undefined || u.color == null){
          u.color = 'linear-gradient(90deg, #8B0391 1.38%, #CB033C 29.44%, #FA0303 59.5%, #8B038D 97.59%)'
        }
        bigDeals.push(u)
      });    
      return bigDeals;
    }));
  }

  emit(deals:any){
    this._bigDeals.next(deals);
  }
}


export class DealBanner{
  src?:string;
  device?:string;

}